
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { useTimeEntries } from '@/hooks/useTimeEntries';
import { startOfWeek, endOfWeek, isWithinInterval } from 'date-fns';
import { getCurrentUser as getCurrentUserFromAuth, type CurrentUser } from '@/utils/authUtils';

const WeeklyStats = () => {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const { timeEntries } = useTimeEntries(currentUser?.id);

  useEffect(() => {
    const getCurrentUser = async () => {
      const user = await getCurrentUserFromAuth();
      setCurrentUser(user);
    };
    getCurrentUser();
  }, []);

  const currentWeekStart = startOfWeek(new Date(), { weekStartsOn: 1 });
  const currentWeekEnd = endOfWeek(new Date(), { weekStartsOn: 1 });

  const thisWeekEntries = timeEntries.filter(entry => 
    isWithinInterval(new Date(entry.start_time), {
      start: currentWeekStart,
      end: currentWeekEnd
    })
  );

  const totalMinutes = thisWeekEntries.reduce((sum, entry) => 
    sum + (entry.duration_minutes || 0), 0
  );
  
  const totalHours = totalMinutes / 60;
  const targetHours = 40; // 40 heures par semaine
  const progress = Math.min((totalHours / targetHours) * 100, 100);

  const billableMinutes = thisWeekEntries
    .filter(entry => entry.is_billable)
    .reduce((sum, entry) => sum + (entry.duration_minutes || 0), 0);
  
  const billableHours = billableMinutes / 60;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Statistiques de la Semaine</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium">Heures Travaillées</span>
            <span className="text-sm text-muted-foreground">
              {totalHours.toFixed(1)}h / {targetHours}h
            </span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="text-center p-3 bg-muted rounded-lg">
            <p className="text-2xl font-bold">{totalHours.toFixed(1)}</p>
            <p className="text-sm text-muted-foreground">Total Heures</p>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <p className="text-2xl font-bold">{billableHours.toFixed(1)}</p>
            <p className="text-sm text-muted-foreground">Heures Facturables</p>
          </div>
        </div>

        <div className="text-center p-3 bg-muted rounded-lg">
          <p className="text-2xl font-bold">{thisWeekEntries.length}</p>
          <p className="text-sm text-muted-foreground">Entrées cette semaine</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default WeeklyStats;
